import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab } from '@mui/material';
import React from 'react'
import EmployeeOverview from './EmployeeOverview';

const ViewEmployee = () => {
    const [value, setValue] = React.useState('1');

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };
  
    return (
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', backgroundColor: '#FFF9EC', p: '0 4%' }}>
            <TabList onChange={handleChange} aria-label="employee tabs" sx={{
                '& .MuiTabs-flexContainer': {
                  gap: '6%', // Adjust this value as needed
                },
                '& .MuiTab-root': {
                  fontSize: '1rem',
                  fontWeight: 500,
                  minWidth: 'unset',
                  padding: '12px 0',
                  '&.Mui-selected': {
                    color: '#D8A630',
                  }
                }
              }}
            >
              <Tab label="Overview" value="1" />
              <Tab label="Salary Details" value="2" />
              <Tab label="Pay Slip" value="3" />
            </TabList>
          </Box>
          <TabPanel value="1" sx={{p: '2% 4%', height: '100%'}}><EmployeeOverview /></TabPanel>
          <TabPanel value="2" sx={{p: '2% 4%'}}>Salary Details</TabPanel>
          <TabPanel value="3" sx={{p: '2% 4%'}}>Pay Slip</TabPanel>
        </TabContext>
      </Box>
    );
}

export default ViewEmployee